import CustomSelector from "./customSelector.jsx";

export default CustomSelector;



// WEBPACK FOOTER //
// ./src/components/common/customSelectorOptions/index.js